import swal from 'sweetalert'
import LeMoulinApi from 'app/universal/utils/LeMoulinApi'

/**
 * Les anciens LMVP (court et long) sont masqués des menus le temps de la
 * bascule vers le LMVP 2026. Repasser à true pour les réafficher.
 */
export const SHOW_LEGACY_LMVP = false

/**
 * Récupère le lien public du LMVP d'une commande groupée et le copie dans le
 * presse-papier, pour le transmettre au client par le canal de son choix.
 *
 * Le lien est créé au premier appel puis réutilisé : un lien déjà transmis reste
 * valable. En cas d'erreur, l'intercepteur axios affiche déjà le message de l'API.
 */
export const copyLmvpPublicLink = async (groupedOrderId) => {
  let url = null

  try {
    const response = await LeMoulinApi.request.order.generateLmvpPublicLink(groupedOrderId)
    url = response?.url ?? response?.data?.url ?? null
  } catch (error) {
    return
  }

  if (!url) {
    return
  }

  try {
    await navigator.clipboard.writeText(url)
    swal({ title: 'Lien public copié', text: url, icon: 'success' })
  } catch (error) {
    // Presse-papier refusé par le navigateur : le lien est affiché pour une copie à la main
    swal({ title: 'Lien public du LMVP', text: url, icon: 'info' })
  }
}

/**
 * Clic sur « LMVP 2026 » : propose de copier le lien public à envoyer au client
 * ou de prévisualiser le document.
 *
 * Sans commande groupée (ancien format), il n'y a pas de lien public : on
 * prévisualise directement.
 */
export const openLmvp = async (previewUrl, groupedOrderId) => {
  const preview = () => window.open(previewUrl, '_blank', 'noopener,noreferrer')

  if (!groupedOrderId) {
    preview()
    return
  }

  const choice = await swal({
    title: 'LMVP 2026',
    text: 'Copier le lien public à envoyer au client, ou prévisualiser le document ?',
    buttons: {
      preview: { text: 'Prévisualiser', value: 'preview', visible: true },
      copy: { text: 'Copier le lien public', value: 'copy', visible: true },
    },
  })

  if (choice === 'preview') {
    preview()
  } else if (choice === 'copy') {
    copyLmvpPublicLink(groupedOrderId)
  }
}
